import {DataGroupModel} from '../../../models/api/dataGroupModel';
import {ThunkAsyncAction} from '../../appThunk';
import {updateDataAction} from '../dataGroupsActions';

export function pushWorkspaceUpdatedAsyncAction(workspaceDataGroup: DataGroupModel): ThunkAsyncAction {
  return async (dispatch) => {
    dispatch(updateDataAction(workspaceDataGroup, {isComingFromPusher: true}));
  };
}
